import React from 'react';
import { Close, Search } from '@material-ui/icons';
import {
  getHighlightedParts,
  getMatchedSnippet,
} from '../../utils/loadedSurfaceSearch';
import './loadedSurfaceSearch.css';

export default function LoadedSurfaceSearch({
  value,
  onChange,
  onClear,
  placeholder,
  ariaLabel,
  clearLabel,
  helperText,
  isActive,
  resultCount,
  statusText,
}) {
  const hasQuery = Boolean(value);

  return (
    <section className="loadedSurfaceSearch">
      <div className="loadedSurfaceSearchControl">
        <Search className="loadedSurfaceSearchIcon" aria-hidden="true" />
        <input
          type="search"
          className="loadedSurfaceSearchInput"
          value={value}
          onChange={(event) => onChange(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === 'Escape') onClear();
          }}
          placeholder={placeholder}
          aria-label={ariaLabel}
        />
        {hasQuery && (
          <button
            type="button"
            className="loadedSurfaceSearchClear"
            aria-label={clearLabel}
            onClick={onClear}
          >
            <Close fontSize="small" aria-hidden="true" />
          </button>
        )}
      </div>
      <div className="loadedSurfaceSearchMeta" aria-live="polite">
        {statusText ||
          (isActive
            ? `${resultCount} ${resultCount === 1 ? 'match' : 'matches'}`
            : helperText)}
      </div>
    </section>
  );
}

export function LoadedSurfaceSearchSnippet({ text, query }) {
  const snippet = getMatchedSnippet(text, query);
  if (!snippet) return null;

  return (
    <div className="loadedSurfaceSearchSnippet">
      <span className="loadedSurfaceSearchSnippetLabel">Match</span>
      <span>
        {getHighlightedParts(snippet, query).map((part, index) =>
          part.match ? (
            <mark key={`${part.text}-${index}`}>{part.text}</mark>
          ) : (
            <React.Fragment key={`${part.text}-${index}`}>
              {part.text}
            </React.Fragment>
          ),
        )}
      </span>
    </div>
  );
}
